import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import NewsletterLogic from '../logics/NewsletterLogic';
import {IS_PRIVACY_PAGE} from '../utils/Environment';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class NewsletterPopupComponent extends Component {

  get SELECTORS() {
    return {
      newsletterFormWrapper: '.news__form__wrapper',
      form: '.w-newsletter-popup .js-newsletter-form',
      jsContent: '.js-modal-form-contents ',
      submitButton: '.js-nl-submission',
      privacyCheckbox: '#privacy-news',
      close: '[data-close-popup]',
      newsletterPopupForm: '#newsletterPopupForm',
      inputEmail: 'input[type=email]'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.close);
    this.form = this.$component.querySelector(this.SELECTORS.newsletterPopupForm);
    this.jsContent = this.$component.querySelector(this.SELECTORS.jsContent);
    this.trapFocusHandler = null;
    this.lastActiveElement = null;
  }

  // istantiate properties
  initProperties() {
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    this.modalkey = $(document.body).data('nlKey') ? $(document.body).data('nlKey') : 'default_modal';
    this.hideCookieKey = 'nl_' + this.modalkey + '_hide';
    this.link = $(document.body).data('nlLink') ? $(document.body).data('nlLink') : contextPath+'/modals/newsletter';
  }

  // enable form submit button
  enableSubmitBtn(submitButton,privacyCheckbox) {
    if ( privacyCheckbox.checked === true ) {
      submitButton.disabled = false;
    } else {
      submitButton.disabled = true;
    }
  }

  // init modal form function
  initModalForm() {
    return $.ajax({
      url: `${this.link}?xhr=true`,
      dataType: 'html'
    });
  }

  // ajax form in the popup
  insertPopupForm() {
    this.initModalForm().then(response => {
      let html = new DOMParser ().parseFromString(response, 'text/html');
      this.log('insert form');
      // inject html
      this.jsContent.innerHTML = html.querySelector('.js-modal-form-contents').innerHTML;
      this.$emit(this.$customEvents.NL_POPUP_EVENTS.show);
    });
  }

  bindEvents() {
    const ctx = this;

    // show events
    // if comm popup is hidden
    this.$on(this.$customEvents.COM_POPUP_EVENTS.hidden, () => {
      // check the cookies
      if(!Cookies.get(this.hideCookieKey) && !IS_PRIVACY_PAGE){
        // insert form
        this.insertPopupForm();
      }
    });

    // show popup
    this.$on(this.$customEvents.NL_POPUP_EVENTS.show, () => {
      // Store the currently focused element to restore later
      this.lastActiveElement = document.activeElement;

      // Show popup and update ARIA attributes
      this.$component.classList.add('show');
      this.$component.setAttribute('aria-hidden', 'false');

      // Set up close button listener
      this.closeBtn.addEventListener('click', () => {
        this.$emit(this.$customEvents.NL_POPUP_EVENTS.hide);
      });

      // Set up ESC key listener for accessibility
      this.handleEscKey = (e) => {
        if (e.key === 'Escape') {
          this.$emit(this.$customEvents.NL_POPUP_EVENTS.hide);
        }
      };
      document.addEventListener('keydown', this.handleEscKey);

      // Set up focus trap
      this.trapFocusHandler = trapFocusOnModal(this.$component);

      // Focus on the first focusable element (email input)
      requestAnimationFrame(() => {
        ctx.$component.querySelector('input[type=email]').focus();
      });
    });

    // hide popup
    this.$on(this.$customEvents.NL_POPUP_EVENTS.hide, () => {
      // Remove focus trap
      if (this.trapFocusHandler) {
        removeTrapFocusOnModal(this.$component, this.trapFocusHandler);
        this.trapFocusHandler = null;
      }

      // Remove ESC key listener
      if (this.handleEscKey) {
        document.removeEventListener('keydown', this.handleEscKey);
        this.handleEscKey = null;
      }

      // Hide popup and update ARIA attributes
      this.$component.classList.remove('show');
      this.$component.setAttribute('aria-hidden', 'true');

      // Restore focus to previous element
      if (this.lastActiveElement) {
        this.lastActiveElement.focus();
        this.lastActiveElement = null;
      }

      this.$emit(this.$customEvents.NL_POPUP_EVENTS.hidden);
    });

    // on hide popup i set the cookie
    this.$on(this.$customEvents.NL_POPUP_EVENTS.hidden, () => {
      Cookies.set(this.hideCookieKey, 'true', {
        expires: 365,
        path: '/'
      });
    });

    // on subscribed popup i set the cookie
    this.$on(this.$customEvents.NL_POPUP_EVENTS.subscribed, () => {
      Cookies.set(this.hideCookieKey, 'true', {
        expires: 365,
        path: '/'
      });
    });

    // privacy button
    this.$on(this.$customEvents.NL_POPUP_EVENTS.show, () => {
      // enable submit on show form
      // bind click
      this.$component.querySelector(this.SELECTORS.privacyCheckbox).addEventListener('click', e => {
        this.enableSubmitBtn(this.$component.querySelector(this.SELECTORS.submitButton),this.$component.querySelector(this.SELECTORS.privacyCheckbox));
      });
    });
    //
    this.$on('submit.newsletter', this.NewsletterLogic.subscribeToNewsletter, 'body', this.SELECTORS.form, this);
  }

  render() {
    this.log('Rendering...');
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
    // properties
    this.initProperties();
    // events
    this.bindEvents();
    // choose to open or wait comm popup to close
    let communicationCookie = Cookies.get('communications-cookie');
    // if there is the cookie, i fire the newsletter popup
    if (communicationCookie || document.querySelector('.w-communication-popup') == null) {
      this.$emit(this.$customEvents.COM_POPUP_EVENTS.hidden);
    }
  }
}
